// @ts-nocheck

import { match as MatchStateUtils } from '..';
import { DefaultVisibleSetsNumbers, NumberPeriodsBySport } from '../../constants/scoreboards';
import { __ } from '../../i18n/l10n';
import type { ScoreboardProps, ScorersType, SecondariesScoreType } from '../../states/scoreboards';
import { MatchTitleAllowedSportIdsAnimation } from '../../types/match';
import { getExtendedMinuteStringFromMatchTime } from '../date';

export const computeScorers = (scorers: Array<unknown> = [], side: string): ScorersType => {
  const hasAtLeastOneScorerName = scorers.filter(({ player }) => player !== '').length > 0;

  // We don't display scorers if we receive only goal times without any scorer name
  return hasAtLeastOneScorerName
    ? scorers.reduce((acc, scorer) => {
        const { scoringTeam, time, stoppageTime, player } = scorer;
        if (
          scoringTeam !== undefined &&
          scoringTeam !== null &&
          scoringTeam === side &&
          time !== undefined &&
          time !== null &&
          player
        ) {
          const formattedTime = getExtendedMinuteStringFromMatchTime(time, stoppageTime);
          return [
            ...acc,
            {
              player: player,
              time: formattedTime,
            },
          ];
        } else {
          return acc;
        }
      }, [])
    : [];
};

export const computeSecondaryScores = (scores: Array<string>): SecondariesScoreType => {
  const finalScores = [];
  const numberOfGamePeriods = NumberPeriodsBySport.ICEHOCKEY;

  // P puis TAB à partir de `numberOfGamePeriods` passés
  scores.map((score, index) => {
    let columnLabel = '';
    if (scores.length > numberOfGamePeriods && index + 1 === numberOfGamePeriods + 2) {
      columnLabel = __('!short:PenaltyShootOut');
    } else if (scores.length > numberOfGamePeriods && index > numberOfGamePeriods - 1) {
      columnLabel = __('!short:Overtime');
    }

    return finalScores.push({
      label: columnLabel,
      score: score.split(':'),
    });
  });

  return finalScores;
};

export default ({
  sportId,
  matchId,
  period,
  periodName,
  setScores,
  competitor1Name,
  competitor2Name,
  competitor1Flag,
  competitor2Flag,
  score,
  scorers,
}: unknown): ScoreboardProps => {
  let scores = null;
  let gameScores = null;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  if (score && score !== '') {
    gameScores = score.split(':');
  }

  return {
    matchId,
    period: periodName || MatchStateUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: competitor1Name,
        flag: competitor1Flag,
        scorers: computeScorers(scorers, 'home'),
      },
      {
        name: competitor2Name,
        flag: competitor2Flag,
        scorers: computeScorers(scorers, 'away'),
      },
    ],
    scores: {
      main: {
        label: __('Total'),
        score: gameScores ? gameScores : ['', ''],
      },
      secondaries: scores ? computeSecondaryScores(scores) : [],
    },
    showTimer: true,
    expandThreshold: 5,
    defaultVisibleSetsNumber: DefaultVisibleSetsNumbers.ICEHOCKEY,
    animatedScore: MatchTitleAllowedSportIdsAnimation.indexOf(Number(sportId)) !== -1,
  };
};
